// Shared decorative SVG primitives — organic, blended dividers + gold heart frame
import React from "react";

export const OrganicWave = ({ flip = false, color = "#ffffff", className = "" }) => (
  <div className={`organic-divider ${className}`} aria-hidden style={{ transform: flip ? "scaleY(-1)" : "none" }}>
    <svg viewBox="0 0 1440 140" preserveAspectRatio="none">
      {/* Back layer — softest, most translucent */}
      <path
        d="M0,70 C160,110 320,30 480,55 C640,80 800,120 960,90 C1120,60 1280,95 1440,75 L1440,140 L0,140 Z"
        fill={color}
        opacity="0.35"
      />
      {/* Middle layer — softer */}
      <path
        d="M0,85 C200,125 400,40 600,75 C800,110 1000,135 1200,95 C1320,72 1400,85 1440,80 L1440,140 L0,140 Z"
        fill={color}
        opacity="0.65"
      />
      {/* Front layer — solid, lowest curve */}
      <path
        d="M0,100 C180,140 380,55 600,90 C820,125 1020,140 1240,110 C1340,98 1400,108 1440,105 L1440,140 L0,140 Z"
        fill={color}
      />
    </svg>
  </div>
);

export const Flourish = ({ color = "#cca300" }) => (
  <div className="flourish" aria-hidden>
    <svg viewBox="0 0 200 30" fill="none" stroke={color}>
      <path d="M2 15 C 30 5, 60 25, 90 15" strokeWidth="1.2" />
      <circle cx="100" cy="15" r="2.5" fill={color} stroke="none" />
      <path d="M110 15 C 140 5, 170 25, 198 15" strokeWidth="1.2" />
      <path d="M88 12 Q 92 8, 96 12" strokeWidth="1.2" />
      <path d="M104 12 Q 108 8, 112 12" strokeWidth="1.2" />
    </svg>
  </div>
);

// Gold heart silhouette with content (image or quote) clipped inside
let _heartCounter = 0;
export const GoldHeart = ({ children, image, size = 280, glow = true, className = "" }) => {
  const id = React.useMemo(() => `gh-${++_heartCounter}`, []);
  return (
    <div className={`relative inline-block ${className}`} style={{ width: size, maxWidth: "100%" }}>
      <svg viewBox="0 0 300 280" style={{ width: "100%", height: "auto", filter: glow ? "drop-shadow(0 25px 35px rgba(91,34,63,0.30))" : "none" }}>
        <defs>
          <clipPath id={id}>
            <path d="M150 260 C30 180, 0 100, 60 50 C100 18, 145 35, 150 80 C155 35, 200 18, 240 50 C300 100, 270 180, 150 260 Z" />
          </clipPath>
          <linearGradient id={`${id}-stroke`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#cca300" />
            <stop offset="100%" stopColor="#d97756" />
          </linearGradient>
        </defs>
        {image
          ? <image href={image} width="300" height="280" preserveAspectRatio="xMidYMid slice" clipPath={`url(#${id})`} />
          : <path d="M150 260 C30 180, 0 100, 60 50 C100 18, 145 35, 150 80 C155 35, 200 18, 240 50 C300 100, 270 180, 150 260 Z" fill="#fdfaf6" clipPath={`url(#${id})`} />
        }
        <path d="M150 260 C30 180, 0 100, 60 50 C100 18, 145 35, 150 80 C155 35, 200 18, 240 50 C300 100, 270 180, 150 260 Z" fill="none" stroke={`url(#${id}-stroke)`} strokeWidth="6" />
      </svg>
      {children && (
        <div className="absolute inset-0 flex items-center justify-center px-6 pb-6 pt-4 pointer-events-none">
          <div className="text-center pointer-events-auto">{children}</div>
        </div>
      )}
    </div>
  );
};
